import { render, staticRenderFns } from "./records3.vue?vue&type=template&id=7f6ffdfc&scoped=true"
import script from "./records3.vue?vue&type=script&lang=js"
export * from "./records3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6ffdfc",
  null
  
)

export default component.exports